/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useMemo, useRef, useState} from 'react'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import './NewPurchaseCreditModal.scss'
import {useDispatch, useSelector} from 'react-redux'
import Promocodepopup from './modal/Promocodepopup'
import SmsMmsPopup from './modal/SmsMmsPopup'
import CardPaymentPopup from './modal/CardPaymentPopup'
import {Elements} from '@stripe/react-stripe-js'
import {GetProductList} from '../../Redux/AdminPanel/PurchaseCreditSlice'
import {GeneralDataOFLoginUser} from '../../Utils/Auth'
import PriceViewPopup from './modal/PriceViewPopup'
import StripeJSProvider from '../../Utils/StripeJSProvider'
import clsx from 'clsx'

import {FeGetPriceRuleList} from '../AdminPages/Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'

import {usePricingRulesMutation} from '../../../services/cellcast.v3'
import {CampType, PaymentPricingRules} from '../../../services/cellcast.v3.types'
import {getAllUserDetails, getIsDefaultRegion} from '../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ExclamationCircle} from 'react-bootstrap-icons'
import CreditSelection from './CreditSelection'
import {CouponRate} from '../../../services/cellcast.type'
import {useAdminGetGlobalSettingQuery, useLazyGetDefaultCouponRateQuery} from '../../../services/cellcast'

const NewPurchaseCreditModalV2 = () => {
  const {data} = useAdminGetGlobalSettingQuery(null)
  const globalSetting = (data?.data || []).find((item) => item?.name === 'GLOBAL_SETTING')

  const maxCredit = 500000
  const minCredit = 20
  const dispatch = useDispatch()
  const accountId = GeneralDataOFLoginUser()?.user?.accountId
  const defaultCoupon = GeneralDataOFLoginUser()?.user?.defaulCoupon
  const userDetail = useSelector(getAllUserDetails)

  const purchaseCreditInputref: any = useRef()
  const [card, setCard] = useState(false)
  const [noOfCredit, setNoOFCredit] = useState<any>(0)
  const [minCouponCredit, setMinCouponCredit] = useState<any>(0)
  const [couponFlatRate, setCouponFlatRate] = useState<any>(0)
  const [quickSms, setQuickSms] = useState('sms')
  const [checkBox, setCheckBox] = useState(false)
  const [viewPricePopup, setViewPricePopup] = useState(false)
  const [price, setPrice] = useState(0)
  const [discount, setDiscount] = useState<any>(0)
  const [couponId, setCouponId] = useState('')
  const [flatRate, setFlatRate] = useState<any>(0)
  const [freeCredit, setFreeCredit] = useState<any>(0)
  const [couponCode, setCouponCode] = useState<any>('')
  const [discountPercentage, setPercentage] = useState<any>(0)

  /** Banner Coupon  */
  const [couponData, setCouponData] = useState<any>(null)
  const [manualCouponData, setManualCouponData] = useState<any>(null)

  const [error, setError] = useState('')
  const [leastPrice, setleastPrice] = useState<any>(20)
  const [showContactInfo, setShowContactInfo] = useState<any>(false)
  const userData: any = GeneralDataOFLoginUser()?.globalSettingData?.[0]?.value
  const [promocodePopup, setPromocodePopup] = useState<any>(false)
  const [defaultCouponRate, setDefaultCouponRate] = useState<CouponRate[]>([])

  const ApplyPromoCode = useMemo(
    () => (
      <Promocodepopup
        setDiscount={setDiscount}
        setPercentage={setPercentage}
        setCouponId={setCouponId}
        setFlatRate={setFlatRate}
        setMinCouponCredit={setMinCouponCredit}
        setCouponFlatRate={setCouponFlatRate}
        checkBox={checkBox}
        quickSms={quickSms}
        price={price}
        noOfCredit={noOfCredit}
        show={promocodePopup}
        handleClose={() => setPromocodePopup(false)}
        setFreeCredit={setFreeCredit}
        setCouponCode={setCouponCode}
        setManualCouponData={setManualCouponData}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [promocodePopup]
  )

  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const restAllData = () => {
    setDiscount(0)
    setFlatRate(0)
    setCheckBox(false)
    setCard(false)
    setCouponId('')
    setPrice(0)
    setNoOFCredit(0)
    setCouponCode('')
    setFreeCredit(0)
    setPercentage(0)
  }
  const handleChange = (event: any) => {
    if (!isNaN(event)) {
      setFlatRate(0)
      setNoOFCredit(event.trim())
    }
  }
  const handleNumberConvert = (val: any) => {
    const data: any = new Intl.NumberFormat('en-US').format(val)
    return data
  }

  const handleError = (value: any) => {
    const minCredits =
       quickSms == 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)

    if (isNaN(+value)) {
      setError('Credit must be Integer')
      return
    }
    if (!(+value <= +maxCredit)) {
      setError(`Credit should be less than max ${maxCredit}`)
      return
    }
    if (!(+value >= +minCredits)) {
      setError(
        `Credit must be greater than ${
          quickSms === 'sms'
            ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
            : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)
        }`
      )
      return
    }
    if (value <= maxCredit && value >= minCredit) {
      setError('')
      return
    }
  }

  const [pricingRules, {data: RateCardList}] = usePricingRulesMutation()

  const [smsdetailpopup, setsmsdetailpopup] = useState<any>(false)
  const ApplysmsPopup = useMemo(
    () => <SmsMmsPopup show={smsdetailpopup} handleClose={() => setsmsdetailpopup(false)} />,
    [smsdetailpopup]
  )

  const getPricingRules = () => {
    if (isDefaultRegion && accountId) {
      dispatch(FeGetPriceRuleList({accountId: accountId}))
      return
    }

    pricingRules({
      action: 'find_pricing_rules',
      data: {
        accountId: accountId,
      },
    })
  }
  useEffect(() => {
    dispatch(GetProductList())
    getPricingRules()
    purchaseCreditInputref?.current?.focus()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const defaultRegionPriceListSMS = useSelector(
    (state: any) => state?.priceRules?.RateCardList
  )?.filter((key: any) => key?.type === 'SMS')
  const defaultRegionPriceListMMS = useSelector(
    (state: any) => state?.priceRules?.RateCardList
  )?.filter((key: any) => key?.type === 'MMS')

  const otherRegionPriceListSMS = RateCardList?.data?.filter(
    (key: PaymentPricingRules) => key?.Type === CampType.sms.toUpperCase()
  )
  const otherRegionPriceListMMS = RateCardList?.data?.filter(
    (key: PaymentPricingRules) => key?.Type === CampType.mms.toUpperCase()
  )

  const PriceRateListSMS = isDefaultRegion ? defaultRegionPriceListSMS : otherRegionPriceListSMS
  const PriceRateListMMS = isDefaultRegion ? defaultRegionPriceListMMS : otherRegionPriceListMMS

  const [fetchDefaultCouponRate] = useLazyGetDefaultCouponRateQuery()

  useEffect(() => {
    if (defaultCoupon !== '') {
      fetchDefaultCouponRate(null).then((res) => {
        if (res.data && Array.isArray(res.data.data)) {
          setDefaultCouponRate(res.data.data)
        }
      })
    }
  }, [defaultCoupon, fetchDefaultCouponRate])

  useEffect(() => {
    /** Other Region */
    if (!isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let leastRate = PriceRateListSMS?.find(
          (key: PaymentPricingRules) =>
            key?.CreditEndRange >= +minCredit && key?.CreditStartRange <= +minCredit
        )?.FinalPrice
        setleastPrice(leastRate)
      } else {
        let leastRate = PriceRateListMMS?.find(
          (key: PaymentPricingRules) =>
            key?.CreditEndRange >= +minCredit && key?.CreditStartRange <= +minCredit
        )?.FinalPrice
        setleastPrice(leastRate)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickSms, minCredit])

  useEffect(() => {
    /** Default Region */
    if (isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let leastRate = PriceRateListSMS?.find(
          (key: any) => key?.creditendrange >= +minCredit && key?.creditstartrange <= +minCredit
        )?.finalPrice
        setleastPrice(leastRate)
      } else {
        let leastRate = PriceRateListMMS?.find(
          (key: any) => key?.creditendrange >= +minCredit && key?.creditstartrange <= +minCredit
        )?.finalPrice
        setleastPrice(leastRate)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickSms, minCredit])

  useEffect(() => {
    /** Other region */
    if (!isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let price =
          PriceRateListSMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
          ) === undefined
            ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
              PriceRateListSMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange ===
                  Math.max(...PriceRateListSMS.map((o: PaymentPricingRules) => o?.CreditEndRange))
              )?.FinalPrice
            : PriceRateListSMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
              )?.FinalPrice
        setPrice(price as number)
      } else {
        let price =
          PriceRateListMMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
          ) === undefined
            ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
              PriceRateListMMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange ===
                  Math.max(...PriceRateListMMS.map((o: PaymentPricingRules) => o?.CreditEndRange))
              )?.FinalPrice
            : PriceRateListMMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
              )?.FinalPrice
        setPrice(price as number)
      }

      if (noOfCredit > 500000) {
        setShowContactInfo(true)
      } else {
        setShowContactInfo(false)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickSms, noOfCredit, PriceRateListSMS, PriceRateListMMS])

  const setDefaultCoupon = (metadata: any) => {
    if (metadata?.flat_rate && metadata?.discount_type === 'fixed_price') {
      setFlatRate(+metadata?.flat_rate)
      setDiscount(0)
      setCouponFlatRate(+metadata?.flat_rate)
      setFreeCredit(0)
      setPercentage(0)
      setCouponCode(metadata?.code)
      setCouponId(metadata?.id)
    }

    if (metadata?.discount_type === 'percentage') {
      const discount = parseInt(metadata?.percentage_off ?? 0, 10);
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(0)
      setPercentage(discount)
      setCouponCode(metadata?.code)
      setCouponId(metadata?.id)
    }

    if (metadata?.discount_type === 'free_credit') {
      const freeCredit = parseInt(metadata?.free_credit ?? 0, 10);
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(freeCredit)
      setPercentage(0)
      setCouponCode(metadata?.code)
      setCouponId(metadata?.id)
    }
  }

  useEffect(() => {
    /** Default region */
    if (isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let price =
          PriceRateListSMS?.find(
            (key: any) => key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
          ) === undefined
            ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
              PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  Math.max(...PriceRateListSMS.map((o: any) => o?.creditendrange))
              )?.finalPrice
            : PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
              )?.finalPrice
        setPrice(price as number)
      } else {
        let price =
          PriceRateListMMS?.find(
            (key: any) => key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
          ) === undefined
            ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
              PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  Math.max(...PriceRateListMMS.map((o: any) => o?.creditendrange))
              )?.finalPrice
            : PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
              )?.finalPrice
        setPrice(price as number)
      }

      // handle coupon with mininmum credit
      if(couponId !== "" && minCouponCredit > 0){
        if(noOfCredit >= minCouponCredit){
          setFlatRate(couponFlatRate)
        } else {
          setFlatRate(0)
        }
      }

      if (noOfCredit > 500000) {
        setShowContactInfo(true)
      } else {
        setShowContactInfo(false)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickSms, noOfCredit, PriceRateListSMS, PriceRateListMMS])

  useEffect(() => {
    if (!isDefaultRegion) return
    if (userDetail?.hasUsedCoupon) return
    if (defaultCouponRate.length === 0) return

    // apply default coupon
    const match = defaultCouponRate.find((r) => {
      if (+r.min_credit > 0 && +r.max_credit > 0) {
        return noOfCredit >= +r.min_credit && noOfCredit <= +r.max_credit
      } else if (+r.min_credit > 0 && +r.max_credit === 0) {
        return noOfCredit >= +r.min_credit
      } else if (+r.min_credit === 0 && +r.max_credit > 0) {
        return noOfCredit <= +r.max_credit
      }
      return false
    })

    if (match) {
      setDefaultCoupon(match)
    } else {
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(0)
      setPercentage(0)
      setCouponCode('')
      setCouponId('')
      setManualCouponData(null)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCouponRate, noOfCredit])

  useEffect(() => {
    const minCredit = parseInt(manualCouponData?.min_credit ?? "0", 10)
    const maxCredit = parseInt(manualCouponData?.max_credit ?? "0", 10)
    const withinMin = !minCredit || noOfCredit >= minCredit
    const withinMax = !maxCredit || noOfCredit <= maxCredit
    const isEligible = withinMin && withinMax

    if (defaultCouponRate?.length === 0 && !isEligible) {
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(0)
      setPercentage(0)
      setCouponCode('')
      setCouponId('')
      setManualCouponData(null)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noOfCredit])
  
  useEffect(() => {
    if (defaultCouponRate?.length === 0) return

    setCouponData(defaultCouponRate[defaultCouponRate?.length - 1])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCouponRate])

  const sliderShow = useMemo(
    () => (
      <Slider
        // defaultValue={50000}
        value={noOfCredit}
        min={20}
        max={200000}
        step={1}
        marks={{0: '0', 200000: '200000'}}
        onChange={(e: any) => {
          if (discount !== 0) {
            setNoOFCredit(e)
            setDiscount(0)
            handleError(e)
          } else {
            setNoOFCredit(e)
            handleError(e)
          }
        }}
        style={{width: '80%'}}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [noOfCredit]
  )

  const viewPriceModel = useMemo(
    () => <PriceViewPopup show={viewPricePopup} handleClose={() => setViewPricePopup(false)} />,
    [viewPricePopup]
  )

  let discountedPrice = price * (1 - discount / 100)

  let unitPrice = price

  if (flatRate) {
    unitPrice = flatRate?.toFixed(3)
  }

  if (discount > 0) {
    unitPrice = +discountedPrice
  }

  const calculateTotalPrice = ({
    credit,
    unitPrice,
    freeCredit,
    flatRate,
    discountPercentage
  }: {
    credit: number;
    unitPrice: number;
    freeCredit?: number;
    flatRate?: number;
    discountPercentage?: number;
  }) => {
    // reduce credits first if freeCredit coupon exists
    const effectiveCredit = Math.max(0, credit - (freeCredit ?? 0));
    let subtotal = effectiveCredit * +unitPrice;
    if (flatRate) {
      subtotal = effectiveCredit * +flatRate;
    } 

    let discountAmount = 0;
    if (discountPercentage) {
      discountAmount = (subtotal * discountPercentage) / 100;
    }

    const totalPrice = Math.max(0, subtotal - discountAmount);
    return totalPrice;
  };

  const credit = +noOfCredit
  // const totalPrice = credit * +unitPrice
  const subTotal = calculateTotalPrice({
    credit: credit,
    unitPrice: +unitPrice,
    freeCredit: freeCredit,
    flatRate: flatRate,
    discountPercentage: discountPercentage
  })

  const getCouponValue = () => {
    let value = ''
    if (freeCredit) {
      value = `${freeCredit} Credit`
    } else if (flatRate) {
      value = flatRate
    } else if (discountPercentage) {
      value = `${discountPercentage}%`
    }

    return value;
  }

   const handleCalculateDiscount = (initialDiscount: number) => {
    // const subTotal = +noOfCredit * +price

    const calculatedDiscount = (leastPrice ?? +unitPrice) * Number(noOfCredit) - subTotal
    return initialDiscount + calculatedDiscount
  }

  const handleCalculateDiscountPercentage = (initialDiscount?: number, creditAmount?: number) => {
    let amount = creditAmount ? creditAmount : noOfCredit
    const subTotalRef = amount * +leastPrice
    const calculatedDiscount = handleCalculateDiscount(initialDiscount || 0)
    return (((initialDiscount || 0) + calculatedDiscount) / subTotalRef) * 100
  }

  const additionalFee = useMemo(() => {
    if (!globalSetting || !(globalSetting as any).value)
      return { percentage: 0, amount: 0 }

    const isAdditionalFeeEnabled = (globalSetting as any).value['ENABLE_ADDITIONAL_FEE']

    let fee = { percentage: 0, amount: 0 }

    if (isAdditionalFeeEnabled) {
      const totalPurchaseAmount = +subTotal * 1.1
      const minimumPurchaseAmmount = parseFloat((globalSetting as any).value['MINIMUM_PURCHASE_AMOUNT'] || 0)

      if (+totalPurchaseAmount >= +minimumPurchaseAmmount) {
        const percentage = parseFloat((globalSetting as any).value['ADDITIONAL_FEE_PERCENTAGE'] || 0)
        fee = {
          percentage,
          amount: (+totalPurchaseAmount * percentage) / 100,
        }
      }
    }

    return fee
  }, [globalSetting, subTotal])

  return (
    <div>
      {ApplyPromoCode}
      {ApplysmsPopup}
      {viewPriceModel}
      <div className='card select-credit'>
        <div className='row m-0'>
          <div className='col-lg-7 px-10' style={{marginBottom: '24px', marginTop: '24px'}}>
            <div
              className='d-flex border-0 shadow-sm rounded-3'
              style={{backgroundColor: '#F3F0FB', padding: '16px'}}
            >
              <div className='d-flex align-items-center gap-3'>
                <ExclamationCircle className='text-primary' style={{fontSize: '30px'}} />
                <div className='text-dark'>
                  <p className='mb-0' style={{fontSize: '15px', letterSpacing: '0%'}}>
                    Cellcast offers a wholesale pricing model. The more you buy, the CHEAPER the
                    credits get, and they never expire! For more info, visit
                    <a
                      onClick={() => setViewPricePopup(true)}
                      className='text-decoration-underline fw-boldest ms-1 cursor-pointer'
                      style={{color: '#008FFB'}}
                    >
                      our full pricing table
                    </a>
                    .
                  </p>
                </div>
              </div>
            </div>

            <div className='credit-purchase' style={{marginTop: '24px'}}>
              <h5 className='mb-5'>What type of credits would you like to purchase? </h5>

              <ul className='nav nav-tabs'>
                <li className='nav-item me-3 mb-3'>
                  <button
                    className={`fw-boldest nav-link btn btn-outline btn-outline-dashed btn-outline-green w-100 p-4 px-6 ${
                      quickSms === CampType.sms && 'active'
                    }`}
                    onClick={(e: any) => {
                      setError('')
                      if (discount !== 0) {
                        setQuickSms(CampType.sms)
                        setDiscount(0)
                        setFlatRate(0)
                      } else {
                        setQuickSms(CampType.sms)
                      }
                    }}
                  >
                    SMS
                  </button>
                </li>
                <li className={clsx('nav-item me-3 mb-3', {'d-none': !isDefaultRegion})}>
                  <button
                    className={`fw-boldest nav-link btn btn-outline btn-outline-dashed btn-outline-blue w-100 p-4 px-6 ${
                      !(quickSms === CampType.sms) && 'active'
                    }`}
                    onClick={(e: any) => {
                      setError('')
                      if (discount !== 0) {
                        setQuickSms(CampType.mms)
                        setDiscount(0)
                        setFlatRate(0)
                      } else {
                        setQuickSms(CampType.mms)
                      }
                    }}
                  >
                    MMS
                  </button>
                </li>
              </ul>

              <CreditSelection
                discount={discount}
                error={error}
                handleChange={handleChange}
                handleError={handleError}
                handleSetDiscount={setDiscount}
                maxCredit={maxCredit}
                leastPrice={leastPrice}
                priceRateList={{
                  sms: PriceRateListSMS,
                  mms: PriceRateListMMS,
                }}
                noOfCredit={noOfCredit}
                quickSms={quickSms as CampType.sms | 'mms'}
                minCredit={{
                  sms: Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? minCredit),
                  mms: Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? minCredit),
                }}
                purchaseCreditInputRef={purchaseCreditInputref}
              />
            </div>
          </div>

          <div className='col-lg-5 pe-0'>
            <div className='select-quantity'>
              {noOfCredit <= 0 || error ? (
                <div className='quantity-top'>
                  <h5 style={{marginBottom: '64px'}}>Select your credit quantity</h5>
                  <span className='icon'>
                    <svg
                      width='61'
                      height='38'
                      viewBox='0 0 61 38'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M57.75 21.625C59.1307 21.625 60.25 20.5057 60.25 19.125C60.25 17.7443 59.1307 16.625 57.75 16.625V21.625ZM1.63848 17.3572C0.662172 18.3335 0.662172 19.9165 1.63848 20.8928L17.5484 36.8027C18.5247 37.779 20.1076 37.779 21.0839 36.8027C22.0602 35.8264 22.0602 34.2434 21.0839 33.2671L6.94178 19.125L21.0839 4.98286C22.0602 4.00655 22.0602 2.42364 21.0839 1.44733C20.1076 0.47102 18.5247 0.47102 17.5484 1.44733L1.63848 17.3572ZM57.75 16.625H3.40625V21.625H57.75V16.625Z'
                        fill='#7950F2'
                      />
                    </svg>
                  </span>
                  <p style={{marginLeft: '70px', marginRight: '70px'}}>
                    Choose a credit type and decide the amount of credit you need.
                  </p>
                </div>
              ) : (
                <>
                  {showContactInfo && (
                    <>
                      <div className='Notification-msg'>
                        <svg
                          width='17'
                          height='18'
                          viewBox='0 0 17 18'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle cx='8.5' cy='9' r='8.5' fill='#FDE5AC' />
                          <path d='M8.5 5.5V11' stroke='#FAC04C' stroke-linecap='round' />
                          <circle cx='8.5' cy='13' r='0.5' fill='#FAC04C' />
                        </svg>

                        <p>
                          Need better pricing? Contact your account manager or{' '}
                          <a href='mailto:info@cellcast.com.au'>info@cellcast.com.au</a>
                        </p>
                      </div>
                    </>
                  )}
                  <div>
                    <h5>Payment Summary</h5>
                    <div className='center-summary'>
                      <div className='d-flex justify-content-between mb-1'>
                        <p>Credit Type</p>
                        <span>{`${quickSms.toLocaleUpperCase()} Credit`}</span>
                      </div>
                      <div className='d-flex justify-content-between mb-1'>
                        <p>Amount</p>
                        <span>{handleNumberConvert(Math.ceil(noOfCredit))}</span>
                      </div>
                      <div className='d-flex justify-content-between mb-1'>
                        <p>Cost per Credit</p>
                        <span>
                          {discount === 0 && leastPrice > price && (
                            <span
                              className='fw-normal'
                              style={{textDecoration: 'line-through', opacity: 0.5}}
                            >
                              {leastPrice}
                            </span>
                          )}
                          {discount !== 0 && (
                            <span style={{textDecoration: 'line-through', opacity: 0.5}}>
                              {price}
                            </span>
                          )}{' '}
                          {discount !== 0 ? +discountedPrice : unitPrice}
                        </span>
                      </div>
                      {couponCode && (
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                          <div className='d-flex gap-2 align-items-center'>
                            <p className="mb-0">Coupon</p>
                            <span
                              className='badge bg-primary text-white rounded-3 text-xs'
                            >
                              {couponCode}
                            </span>
                          </div>
                          <span>{getCouponValue()}</span>
                        </div>
                      )}
                    </div>

                    {handleCalculateDiscountPercentage(discount ?? discountPercentage) > 0 && (
                      <div className='alert' role='alert'>
                        <i className='bi bi-info-circle'></i>
                        <span>
                          You are saving $
                          {handleNumberConvert(handleCalculateDiscount(discount ?? discountPercentage).toFixed(0))} (
                          {handleCalculateDiscountPercentage(discount ?? discountPercentage).toFixed(0)}%)
                        </span>
                      </div>
                    )}

                    <hr className='my-4' />

                    <div className='bill-price'>
                      <div className='d-flex justify-content-between mb-1'>
                        <p>Sub Total</p>
                        <span className='fw-normal'>
                          ${handleNumberConvert(subTotal.toFixed(2))}
                        </span>
                      </div>
                      <div className='d-flex justify-content-between mb-1'>
                        <p>GST</p>
                        <span className='fw-normal'>
                          {handleNumberConvert((+subTotal * 0.1).toFixed(2))}
                        </span>
                      </div>
                      <div className='d-flex justify-content-between mb-1'>
                        <p>Discount</p>
                        <span className='fw-normal'>
                          ${handleNumberConvert(handleCalculateDiscount(discount).toFixed(0))}
                        </span>
                      </div>

                      {additionalFee?.amount !== 0 && (
                        <div className='d-flex justify-content-between mb-1'>
                          <p>
                            Credit card transaction fee
                          </p>
                          <span className='fw-normal'>
                            {handleNumberConvert(additionalFee?.amount.toFixed(2))}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className='billing-summary d-flex justify-content-between mt-2'>
                      <span>Billed Now</span>
                      <span>${handleNumberConvert(((+subTotal * 1.1) + (additionalFee?.amount ?? 0)).toFixed(2))}</span>
                    </div>
                  </div>
                </>
              )}
              <div className='quantity-bottom'>
                <button
                  disabled={noOfCredit <= 0 || error !== ''}
                  className='CreditButton'
                  onClick={() => setCard(true)}
                >
                  Checkout
                </button>

                {noOfCredit > 0 && !userDetail?.hasUsedCoupon && !error && (
                  <span className='coupon'>
                    Have a coupon code?{' '}
                    <a href='#' onClick={() => setPromocodePopup(true)}>
                      Add here
                    </a>
                  </span>
                )}

                <StripeJSProvider>
                  {({stripe}: any) =>
                    stripe ? (
                      <Elements stripe={stripe}>
                        <CardPaymentPopup
                          restData={() => restAllData()}
                          show={card}
                          minCouponCredit={minCouponCredit}
                          handleClose={() => {
                            setCard(false)
                            setDiscount(0)
                            setFlatRate(0)
                            setCheckBox(false)
                            setCard(false)
                            setCouponId('')
                            setPrice(0)
                            setNoOFCredit(0)
                            setMinCouponCredit(0)
                          }}
                          total={handleNumberConvert(((+subTotal * 1.1) + (additionalFee?.amount ?? 0)).toFixed(2))}
                          customData={{
                            priceperItems: unitPrice,
                            type: quickSms,
                            credits: !checkBox
                              ? +noOfCredit
                              : Math.ceil(+noOfCredit + +noOfCredit * 0.3),
                          }}
                          couponId={couponId}
                        />
                      </Elements>
                    ) : null
                  }
                </StripeJSProvider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='card py-5 px-10'>
        <div className='card-header border-0 my-3 mb-8 p-0 d-block'>
          <div className='card-title align-items-start flex-column mb-3'>
            <span className='card-label fw-bolder fs-4'>Frequently Asked Questions</span>
          </div>
          <p className='text-muted'>
            Explore our FAQ section for quick answers on pricing, and more. Need further assistance?
            Our support team is here to help!
          </p>

          <div className='row question_box'>
            <div className='col-lg-12'>
              <h5>Pricing</h5>

              <div className='accordion' id='accordionExample'>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingOne'>
                    <button
                      className='accordion-button'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseOne'
                      aria-expanded='true'
                      aria-controls='collapseOne'
                    >
                      What is the value of one SMS credit at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseOne'
                    className='accordion-collapse collapse show'
                    aria-labelledby='headingOne'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      One credit equals 160 characters. When composing messages, you will see a
                      character count for reference. Note that using a Custom ID or Dedicated number
                      incurs a charge of 1.3 credits per message.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingTwo'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseTwo'
                      aria-expanded='false'
                      aria-controls='collapseTwo'
                    >
                      What is the value of one MMS at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseTwo'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingTwo'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      At Cellcast, one MMS allows you to send up to 1500 characters along with a
                      massive 800kb media content such as images, videos, or audio. This makes MMS a
                      versatile option for richer, more engaging communications.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingThree'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseThree'
                      aria-expanded='false'
                      aria-controls='collapseThree'
                    >
                      Do my credits expire?
                    </button>
                  </h2>
                  <div
                    id='collapseThree'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingThree'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      No, credits purchased for Cellcast services do not expire. You can use your
                      credits at any time without worrying about time constraints.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingFour'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseFour'
                      aria-expanded='false'
                      aria-controls='collapseFour'
                    >
                      How does Cellcast pricing work?
                    </button>
                  </h2>
                  <div
                    id='collapseFour'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingFour'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Cellcast offers a wholesale pricing model where you can buy credits in
                      bundles. The larger the bundle, the lower the cost per message, allowing for
                      significant savings. Additionally, these credits never expire, ensuring you
                      can use them at your convenience without any time constraints.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingFive'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseFive'
                      aria-expanded='false'
                      aria-controls='collapseFive'
                    >
                      Does it cost to receive replies or inbound messages at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseFive'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingFive'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      No, receiving replies or inbound messages at Cellcast is completely free.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingSix'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseSix'
                      aria-expanded='false'
                      aria-controls='collapseSix'
                    >
                      What are the benefits of a dedicated number, and how much does it cost?
                    </button>
                  </h2>
                  <div
                    id='collapseSix'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingSix'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Dedicated numbers are a premium messaging option at Cellcast, costing $18 AUD
                      per month or $169 AUD per year. These numbers are exclusive to you, enhancing
                      recipient recognition of your messages. The benefits include increased
                      professionalism, branding, personalisation, security, control, and regulatory
                      compliance. Furthermore, dedicated numbers are less likely to be flagged as
                      spam due to their association with legitimate businesses or organisations. You
                      can purchase these numbers directly on our platform.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingSeven'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseSeven'
                      aria-expanded='false'
                      aria-controls='collapseSeven'
                    >
                      What is the cost difference between sending SMS via a shared number, dedicated
                      number, and Custom ID at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseSeven'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingSeven'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      Sending an SMS via a shared number costs 1 credit for every 160 characters. If
                      you use a dedicated number or a Custom ID, the cost increases to 1.3 credits
                      for the same number of characters. This higher cost reflects the additional
                      benefits of using a dedicated number or Custom ID, such as enhanced branding
                      and recognition.
                    </div>
                  </div>
                </div>
                <div className='accordion-item'>
                  <h2 className='accordion-header' id='headingEight'>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapseEight'
                      aria-expanded='false'
                      aria-controls='collapseEight'
                    >
                      What if I want to purchase more than 100,000 credits at Cellcast?
                    </button>
                  </h2>
                  <div
                    id='collapseEight'
                    className='accordion-collapse collapse'
                    aria-labelledby='headingEight'
                    data-bs-parent='#accordionExample'
                  >
                    <div className='accordion-body'>
                      If you're interested in purchasing more than 100,000 credits, please contact
                      us at support@cellcast.com for custom pricing. Our team will provide you with
                      tailored solutions and competitive rates to meet your large-scale messaging
                      needs.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='help'>
            <svg
              width='25'
              height='31'
              viewBox='0 0 25 31'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                opacity='0.3'
                d='M9.36459 28.9605L2.67084 23.4917C2.09846 23.0295 1.63648 22.4452 1.31859 21.7817C1.0007 21.1182 0.834923 20.3921 0.833344 19.6563V8.93757C0.833884 7.98533 1.10942 7.05352 1.62683 6.25412C2.14424 5.45472 2.8815 4.82176 3.75001 4.43132L10.4583 1.36882C11.1037 1.07367 11.805 0.920898 12.5146 0.920898C13.2242 0.920898 13.9255 1.07367 14.5708 1.36882L21.25 4.43132C22.1185 4.82176 22.8558 5.45472 23.3732 6.25412C23.8906 7.05352 24.1661 7.98533 24.1667 8.93757V19.6563C24.1669 20.3909 24.0033 21.1163 23.688 21.7797C23.3727 22.4432 22.9135 23.028 22.3438 23.4917L15.65 28.9605C14.7661 29.692 13.6547 30.0923 12.5073 30.0923C11.3599 30.0923 10.2485 29.692 9.36459 28.9605Z'
                fill='#7950F2'
              />
              <path
                d='M15.4167 19.4378C15.2763 19.4393 15.1371 19.413 15.0069 19.3604C14.8768 19.3079 14.7583 19.2301 14.6583 19.1316L8.825 13.4295C8.62017 13.2244 8.50513 12.9464 8.50513 12.6566C8.50513 12.3667 8.62017 12.0888 8.825 11.8837C9.03436 11.6814 9.3141 11.5684 9.60521 11.5684C9.89632 11.5684 10.176 11.6814 10.3854 11.8837L16.2187 17.5858C16.4236 17.7908 16.5386 18.0688 16.5386 18.3587C16.5386 18.6485 16.4236 18.9265 16.2187 19.1316C16.1121 19.2334 15.9863 19.313 15.8486 19.3655C15.7108 19.4181 15.564 19.4427 15.4167 19.4378Z'
                fill='#7950F2'
              />
              <path
                d='M9.58335 19.4373C9.43743 19.4383 9.29275 19.4104 9.15761 19.3554C9.02247 19.3003 8.89953 19.2191 8.79585 19.1164C8.59103 18.9113 8.47598 18.6333 8.47598 18.3435C8.47598 18.0537 8.59103 17.7757 8.79585 17.5706L14.6292 11.8685C14.7218 11.7335 14.8435 11.621 14.9854 11.5394C15.1273 11.4577 15.2857 11.4089 15.449 11.3966C15.6122 11.3844 15.7761 11.4089 15.9287 11.4684C16.0812 11.5279 16.2184 11.6209 16.3302 11.7405C16.4419 11.8601 16.5254 12.0033 16.5745 12.1594C16.6236 12.3156 16.637 12.4808 16.6137 12.6429C16.5904 12.8049 16.531 12.9597 16.44 13.0957C16.3489 13.2318 16.2285 13.3456 16.0875 13.4289L10.2542 19.131C10.0714 19.3057 9.83506 19.4136 9.58335 19.4373Z'
                fill='#7950F2'
              />
            </svg>

            <div className='help-detail'>
              <h6>Need more help?</h6>
              <p>
                We're here for you, contact your account manager or send an email to
                info@cellcast.com.au
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewPurchaseCreditModalV2
